import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppPropertyBasicModel, CityModel, HxCityService } from 'hx-services';
import { ActivatedRoute, Data, RouterLink } from '@angular/router';
import { Subject } from 'rxjs';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NzAffixComponent } from 'ng-zorro-antd/affix';
import { HxBreadcrumbsComponent } from '@adm-web-app/components/breadcrumbs/breadcrumbs.component';
import { NzPageHeaderComponent, NzPageHeaderExtraDirective, NzPageHeaderTitleDirective } from 'ng-zorro-antd/page-header';
import { NzButtonComponent, NzButtonGroupComponent } from 'ng-zorro-antd/button';

import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzTableCellDirective, NzTableComponent, NzTbodyComponent, NzTheadComponent, NzThMeasureDirective, NzTrDirective } from 'ng-zorro-antd/table';
import { JsonPipe, NgFor, NgIf } from '@angular/common';
import { NzWaveDirective } from 'ng-zorro-antd/core/wave';
import { NzPopconfirmDirective } from 'ng-zorro-antd/popconfirm';

@Component({
    selector: 'hc-city-properties-list',
    templateUrl: './city-property-list.component.html',
    styleUrls: ['./city-property-list.component.less'],
  imports: [NzAffixComponent, HxBreadcrumbsComponent, NzPageHeaderComponent, NzPageHeaderTitleDirective, NzPageHeaderExtraDirective, NzButtonComponent, RouterLink, NzIconDirective, TranslocoDirective, NzTableComponent, NzTheadComponent, NzTrDirective, NzTableCellDirective, NzThMeasureDirective, NzTbodyComponent, NgFor, NgIf, NzButtonGroupComponent, NzWaveDirective, NzPopconfirmDirective, JsonPipe, TranslocoPipe]
})
export class CityPropertyListComponent implements OnInit, OnDestroy {
  model!: CityModel;
  isLoading = {
    properties: false
  };
  properties: AppPropertyBasicModel[] = [];

  private $destroyed = new Subject<void>();

  constructor(
    private aRoute: ActivatedRoute,
    private cityService: HxCityService,
    private tr: TranslocoService,
  ) {
  }

  ngOnInit() {
    const routeData: Data = this.aRoute.snapshot.data;
    this.model = routeData['model'] as CityModel;
    this.loadProperties();
  }

  remove(id: number): void {
    this.cityService.removeProperty(this.model.id, id).subscribe(() => this.loadProperties());
  }

  ngOnDestroy(): void {
    this.$destroyed.next();
    this.$destroyed.complete();
  }

  private loadProperties() {
    this.isLoading.properties = true;
    this.cityService.getPropertiesById(this.model.id).subscribe(properties => {
      this.properties = properties;
      this.isLoading.properties = false;
    }, () => {
      this.isLoading.properties = false;
    });
  }
}
